
import { Component, Vue } from 'vue-property-decorator';
import PageContainer from '@/components/PageTemplate/PageContainer.vue';
import PageTableOfContents from '@/components/PageTemplate/PageTableOfContents.vue';

@Component({ components: { PageContainer, PageTableOfContents } })
export default class ResultTypes extends Vue {
  get resultsLinks() {
    return [
      {
        sections: [
          {
            name: this.$t('context.resultsPage.pages.keyDefinitions.pageName'),
            routeName: 'keyDefinitions',
          },
        ],
      },
      {
        sectionName: this.$t('context.resultsPage.sectionTitles.1'),
        sections: [
          {
            name: this.$t(
              'context.resultsPage.pages.agriculturalDemand.pageNameShort',
            ),
            routeName: 'agriculturalDemand',
          },
          {
            name: this.$t(
              'context.resultsPage.pages.municipalIndustrialDemand.pageNameShort',
            ),
            routeName: 'municipalIndustrialDemand',
          },
        ],
      },
      {
        sectionName: this.$t('context.resultsPage.sectionTitles.2'),
        sections: [
          {
            name: this.$t(
              'context.resultsPage.pages.agriculturalRisk.pageName',
            ),
            routeName: 'agriculturalRisk',
          },
          {
            name: this.$t(
              'context.resultsPage.pages.municipalIndustrialRisk.pageName',
            ),
            routeName: 'municipalIndustrialRisk',
          },
          {
            name: this.$t(
              'context.resultsPage.pages.environmentalRecreationRisk.pageName',
            ),
            routeName: 'environmentalRecreationRisk',
          },
        ],
      },
      {
        sectionName: this.$t('context.resultsPage.sectionTitles.3'),
        sections: [
          {
            name: this.$t(
              'context.resultsPage.pages.otherResultTypes.pageName',
            ),
            routeName: 'otherResultTypes',
          },
        ],
      },
    ];
  }
}
